import React from 'react';
import { createRoot } from 'react-dom/client';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { syncSessionExpiration } from './Functionalities/sessionManager';
import { sendPickedFranchise } from './Functionalities/pickedFranchise';
import { picked_franchise_id, url } from './Functionalities/Config';

syncSessionExpiration();
sendPickedFranchise(picked_franchise_id, url);

// Initialise Bugsnag before anything else so errors are captured early
Bugsnag.start({
  apiKey: '8a65a0e89af0684926c5828bc59bfac7',
  plugins: [new BugsnagPluginReact()],
});


BugsnagPerformance.start({ apiKey: '8a65a0e89af0684926c5828bc59bfac7' });

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
